import { Card, Grid, Image, styled } from '@grupoboticario/flora-react';

const styles = {
  Card: styled(Card, {
    padding: '$2',
  }),

  CardImage: styled(Image, {
    borderRadius: '$small',
    overflow: 'hidden',
    height: '100%',
    maxHeight: 'calc($8 * 6)',

    '@tablet': {
      height: 'initial',
    },
  }),

  LogoImage: styled(Image, {
    height: '$8',
    maxWidth: 'calc(3 * $10)',
    margin: '$3 0',
  }),

  Grid: styled(Grid, {
    alignItems: 'center',
    columnGap: '$2',
    gridTemplateAreas: `'image content' 
                        'image content'
                        'action action'`,
    gridTemplateColumns: `auto 1fr`,
    gridTemplateRows: '60px 60px auto',

    '> [data-wrapper="buttons"]': {
      marginTop: '$2',
    },

    '@mobile': {
      gap: '$4',
      gridTemplateAreas: `'image content' 
                          'image action'`,
      gridTemplateColumns: `auto 1fr`,
      gridTemplateRows: 'auto auto',

      '> [data-wrapper="buttons"]': {
        marginTop: 'initial',
      },
    },
  }),
};

export default styles;
